import React, { useState, useEffect } from "react";
import clsx from "clsx";

const DEFAULT_TIMEOUT = 10;
const DEFAULT_LOADING_MESSAGE = [
  "Loading large amounts of data.",
  "This could take a bit longer."
];

type LoadingOverlayProps = {
  messageTimeout?: number; // seconds
  message?: string[];
  displayInline?: boolean;
};

const LoadingOverlay = ({
  messageTimeout = DEFAULT_TIMEOUT,
  message = DEFAULT_LOADING_MESSAGE,
  displayInline = false
}: LoadingOverlayProps) => {
  const [showMessage, setShowMessage] = useState<boolean>(false);

  useEffect(() => {
    if (!messageTimeout) return undefined;
    const timer = setTimeout(() => {
      setShowMessage(true);
    }, messageTimeout * 1000);
    return () => clearTimeout(timer);
  }, [messageTimeout]);

  return (
    <span
      className={clsx(
        "loading-overlay",
        message && "loading-overlay--with-message",
        displayInline && "loading-overlay--inline"
      )}
      data-testid="loading_overlay"
    >
      <span className="loading-overlay-inner">
        <span className="k-loading-mask">
          <span className="k-loading-text">Loading...</span>
          {showMessage && (
            <div
              className="loading-overlay__message-container"
              data-testid="loading_overlay_message_container"
            >
              {message?.map((messageLine: string, idx: number) => (
                <div
                  className="loading-overlay__message-line"
                  key={messageLine}
                  data-testid={`loading_overlay_message_line_${idx}`}
                >
                  {messageLine}
                </div>
              ))}
            </div>
          )}
        </span>
      </span>
    </span>
  );
};

export default LoadingOverlay;
